import { Table, TableBody, TableContainer } from '@mui/material';
import { ScheduleEntry } from '../../domain/ScheduleEntry';
import { ScheduleWeek } from '../../domain/ScheduleWeek';
import ScheduleTableEntry from './schedule-table/ScheduleTableEntry';
import { prepareAssigned } from './utils/scheduleUtils';
import { ScheduleView } from './ScheduleContent';

interface Props {
    week?: ScheduleWeek;
    entries: ScheduleEntry[];
    editable?: boolean;
    view?: ScheduleView;
    onEntryUpdate?: (entry: ScheduleEntry) => void;
    onEntryEdit?: (entry: ScheduleEntry) => void;
    onPublisherScheduleHistory?: (entry: ScheduleEntry) => void;
    onEntryAssignmentHistory?: (entry: ScheduleEntry) => void;
    onEntrySendNotification?: (entry: ScheduleEntry) => void;
    onEntryAutoArrange?: (entry: ScheduleEntry) => void;
}

const ScheduleFieldServiceTab = (props: Props) => {
    const assigned = prepareAssigned(props.entries);
    const view = props.view ?? 'default';

    return (
        <TableContainer>
            <Table size="small">
                <TableBody>
                    <ScheduleTableEntry
                        name="intro"
                        week={props.week}
                        entries={props.entries}
                        assigned={assigned}
                        editable={props.editable}
                        view={view}
                        onEntryUpdate={props.onEntryUpdate}
                        onEntryEdit={props.onEntryEdit}
                        onPublisherScheduleHistory={props.onPublisherScheduleHistory}
                        onEntryAssignmentHistory={props.onEntryAssignmentHistory}
                        onEntrySendNotification={props.onEntrySendNotification}
                        onEntryAutoArrange={props.onEntryAutoArrange}
                    />
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default ScheduleFieldServiceTab;